import styled from "styled-components";
import { Avatar, VideoPreview } from "@/ui";

export const StyledLocalVideo = styled(VideoPreview) <{
  $absolute?: boolean;
}>`
  ${({ $absolute }) => $absolute ? 'background-color: var(--color-video-bg-light);' : ''}
  .local-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledAvatar = styled(Avatar)`
  border: 3px solid var(--color-avatar-border);
`;
